'use client';

import React from 'react';
import Link from 'next/link';

const CallToAction: React.FC = () => {
  const mailtoHref =
    "mailto:watson@myaiot.com.my?subject=" +
    encodeURIComponent("GameIt.Lol — Schedule a demo") +
    "&body=" +
    encodeURIComponent(
      "Hi Watson,\n\nI'd like to schedule a demo for GameIt.Lol.\n\nCompany:\nWebsite:\nPreferred time:\nNotes:\n\nThanks!"
    )

  return (
    <section className="py-20 container mx-auto px-6">
      <div className="bg-violet-700 rounded-[3rem] p-12 md:p-20 text-center shadow-2xl shadow-violet-500/20">

        <div className="relative z-10 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-white mb-6">
            Ready to Gamify Your Growth?
          </h2>
          <p className="text-violet-100 text-lg md:text-xl mb-10">
            Start your free starter plan today at no cost. No credit card required. Cancel anytime.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              href="/register"
              className="px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center justify-center gap-2 bg-white text-violet-900 hover:bg-gray-100 hover:shadow-xl shadow-lg"
            >
              Get Started for Free
            </Link>
            <a
              href={mailtoHref}
              className="px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center justify-center gap-2 border-2 border-violet-400 text-white hover:bg-violet-800 hover:border-violet-300"
            >
              Schedule a Demo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
